// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessibilityButton_container__KNygS","button":"AccessibilityButton_button__K9r68"};